





















import { defineComponent, computed, getCurrentInstance } from "vue";
import useAuthentication from "@/composition/useAuthentication";
import CdkNavigationProvider from "@/components/CdkNavigation/CdkNavigationProvider.vue";

// @ts-ignore
export default defineComponent({
  setup() {
    const root = getCurrentInstance();
    const { validateAndRetrieveToken } = useAuthentication();
    const { $i18n, $store } = root.proxy;

    const languages = computed(() => [
      {
        label: $i18n.t("german"),
        value: "de"
      },
      {
        label: $i18n.t("english"),
        value: "en"
      }
    ]);
    const selected = computed({
      get: () => $store.state.language.language,
      set: (language: string) => {
        $store.dispatch("language/setLanguage", {
          language,
          token: validateAndRetrieveToken()
        });
      }
    });

    return { token: validateAndRetrieveToken, languages, selected };
  },
  components: {
    CdkNavigationProvider
  }
});
